import BaseCrudRepository from '@/repositories/BaseCrudRepository';
import HttpClient from '@/util/http/HttpClient';
import SubNavigationItem from '@/repositories/data/sidebar/SubNavigationItem';

export default class SubNavigationItemRepository extends BaseCrudRepository<
    number,
    SubNavigationItem,
    SubNavigationItem
> {
    constructor(client: HttpClient) {
        super(client, 'rest/admin/sub-navigation-item/');
    }
}
